import { Link, useLocation, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { SignOut } from "@phosphor-icons/react";

const NavLink = ({ to, children, testId }) => {
  const { pathname } = useLocation();
  const active = pathname === to;
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`text-[11px] uppercase tracking-[0.2em] font-semibold pb-1 border-b transition-colors duration-200 ${
        active ? "text-foreground border-foreground" : "text-muted-foreground border-transparent hover:text-foreground"
      }`}
    >
      {children}
    </Link>
  );
};

export const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <header className="no-print sticky top-0 z-40 border-b border-border bg-white/85 backdrop-blur-xl">
        <div className="relative mx-auto max-w-[1400px] px-8 lg:px-12 h-[140px] flex flex-col items-center justify-center gap-7">
          <Link to="/" className="block" data-testid="header-home-link">
            <Logo className="h-11 sm:h-14 lg:h-16" />
          </Link>
          <nav className="flex items-center gap-12">
            <NavLink to="/" testId="nav-dashboard">
              Übersicht
            </NavLink>
            <span className="h-3 w-px bg-border" />
            <NavLink to="/neue-analyse" testId="nav-new-analysis">
              Neue Analyse
            </NavLink>
          </nav>
          {user && (
            <button
              data-testid="logout-button"
              onClick={() => {
                logout();
                navigate("/login");
              }}
              className="absolute right-8 lg:right-12 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors duration-200"
              title="Abmelden"
            >
              <SignOut size={18} />
            </button>
          )}
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
};
